import { Action, Dispatch } from 'redux'
import { FirebaseDocRefType } from 'firebase/index'
import { StoreDeliveryFeeType } from 'types/storeDeliveryFee'
import { fetchStoreDeliveryFeesAction } from 'reducks/storeDeliveryFee/actions'

const fetchStoreDeliveryFees = (storeRef: FirebaseDocRefType) => {
  return async (dispatch: Dispatch<Action>) => {
    return storeRef
      .collection('store_delivery_fees')
      .get()
      .then((snapshots) => {
        const list = snapshots.docs.map((snapshot) => {
          const data = snapshot.data() as StoreDeliveryFeeType
          data.ref = snapshot.ref
          return data
        })
        list.sort((a, b) => (a.package_size < b.package_size ? -1 : 1))
        dispatch(fetchStoreDeliveryFeesAction(list))
      })
      .catch((error: unknown) => {
        console.error(error)
      })
  }
}

export default fetchStoreDeliveryFees
